/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import ITemplateModel from 'apmui/master/Model';
import IFormConfiguration from 'apmui/components/form/Model';
import PageType from 'apmui/page/PageType';

const FORM_ID = 'okta_mfa_form';
const NAV_FORM_ID = 'navigation_form';
const FIELD_FACTOR_LIST = 'factors';
const FIELD_TOTP = 'totp';
const FIELD_PUSH = 'push';
const FIELD_OKTA = 'okta';
const FIELD_YUBICO = 'yubico';
const FIELD_SMS = 'sms';
const FIELD_EMAIL = 'email';
const FIELD_MANUAL = 'manual';

/*
 * VERIFY, ENROLL and ACTIVATE are used as type of event
 * in IVerifyEventModel and in uri for htconnector request
 */
const VERIFY = 'verify';
const ENROLL = 'enroll';
const ACTIVATE = 'activate';
const UPDATE = 'update';
const INIT = 'init';

interface IVerifyEventModel {
    factor: string;
    type: string;
    value?: string | boolean;
}

interface IOktaMfaModel extends ITemplateModel {
    pageType: PageType.OKTA_MFA;
    [PageType.OKTA_MFA]: {
        strings: {
            oktaVerifyFactor: string;
            pageTitle: string;
            enterCode: string;
            sendPush: string;
            orEnterCode: string;
            codeError: string;

            mfaSetupTitle: string;
            mfaSetupMsg: string;
            oktaVerifySetup: string;
            moreOptionsToEnroll: string;
            oktaVerifyTotpSetup: string;
            linkSentSms: string;
            linkSentEmail: string;
            smsActivation: string;
            emailActivation: string;
            manualActivation: string;
            phoneError: string;
            enterPhone: string;

            yubicoOtpFactor: string;
            yubicoOtpMsg: string;

            next: string;
            back: string;
            verify: string;
            factorEnrollmentTitle: string;
        };
        state: {
            renderForm: boolean;
            hasEnrollInfo: boolean;
            enrollInfo: {
                qrcode: string;
                secret: string;
            };
            pushEnrollInfo: {
                qrcode: string;
                smsLink: string;
                emailLink: string;
            };
            currentFactor: string;
            showEnrollPageBtn: boolean;
            linkSent: boolean;
            isPush: boolean;
            isOtp: boolean;
            isYubico: boolean;
            isEnrollment: boolean;
            isMoreOption: boolean;
            phoneNumber: string;
        };
        form: IFormConfiguration;
    };
}

export {
    IOktaMfaModel as default,
    IOktaMfaModel,
    IVerifyEventModel,
    FORM_ID,
    NAV_FORM_ID,
    FIELD_FACTOR_LIST,
    FIELD_TOTP,
    FIELD_PUSH,
    FIELD_OKTA,
    FIELD_YUBICO,
    FIELD_SMS,
    FIELD_EMAIL,
    FIELD_MANUAL,
    UPDATE,
    VERIFY,
    ENROLL,
    ACTIVATE,
    INIT,
};
